import React from 'react';
import { Container, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

const RegistrationFormPage: React.FC = () => {
  const { clubId } = useParams();
  
  return (
    <Container>
      <Typography variant="h4">Registration Form</Typography>
      <Typography>Club ID: {clubId}</Typography>
      <Typography>Registration form will be implemented here</Typography>
    </Container>
  );
};

export default RegistrationFormPage;